import React, { useState } from 'react'
import { Card, CardHeader, Typography } from '@mui/material'
import {
  ComposedChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
  Label,
  LabelList
} from 'recharts'
import { DashboardBsaleContextType, useDashboardBsaleContext } from '../../../context/dashboardBsale.context'
import { CurrencyFormat } from '@utils/Currency.utility'
import { month, average, formatNumber } from '@utils/dashboardBsale'

function TotalSale () {
  const { ctx } = useDashboardBsaleContext() as DashboardBsaleContextType
  const salesAverage = average(ctx.totalSales, 'total_neto_2024')
  const [hide, setHide] = useState<any>([])

  const order = (sales: any) => {
    if (sales.some((ele: any) => ele.total_ventas_2024 === '0')) {
      const year2023:any = sales.filter((ele: any) => ele.total_ventas_2024 === '0')
      const year2024:any = sales.filter((ele: any) => ele.total_ventas_2024 !== '0')
      const newData = [...year2023, ...year2024].map((ele: any) => {
        return {
          ...ele,
          month: month(ele.month),
          total_ventas_2024: ele.total_ventas_2024 === '0' ? null : ele.total_ventas_2024,
          total_devoluciones_2024: ele.total_devoluciones_2024 === '0' ? null : ele.total_devoluciones_2024
        }
      })
      return newData
    } else {
      const newData = sales.map((ele: any) => {
        return {
          ...ele,
          month: month(ele.month)
        }
      })
      return newData
    }
  }

  const years = ctx.totalSales.map(ele => {
    const asd = Object.keys(ele).filter(ele => ele.includes('ventas'))
    return asd
  }).pop()?.flatMap(ele => ele.split('_').slice(-1)).sort((a: any, b: any) => a - b)

  const colors: any = {
    2022: '#0473c8',
    2023: '#ff7300',
    2024: '#413ea0'
  }

  const handleLenged = (e: any) => {
    if (hide.includes(e.id)) {
      const data = hide.filter((ele: any) => ele !== e.id)
      setHide(data)
    } else {
      setHide([...hide, e.id])
    }
  }

  const maxSales = Math.max(...ctx?.totalSales.flatMap(ele => Object.values(ele)))
  

  return (
    <Card sx={{ height: 400 }}>
      <CardHeader title={<Typography variant='h6'>Total ventas</Typography>} />
      <ResponsiveContainer width='100%' height='80%'>
        <ComposedChart
          width={500}
          height={400}
          data={ctx && order(ctx?.totalSales)}
          margin={{
            top: 20,
            right: 20,
            bottom: 20,
            left: 50
          }}
        >
          <CartesianGrid stroke='#f5f5f5' />
          <XAxis dataKey='month' />
          <YAxis
            domain={!years?.every(year => hide.includes(`total_neto_${year}`)) ? [0, maxSales] : undefined}
            tickFormatter={formatNumber}
          />
          <Tooltip
            formatter={(value: any, name: any, props: any) => CurrencyFormat(value)}
          />
          <Legend
            wrapperStyle={{ cursor: 'pointer' }}
            onClick={handleLenged}
            payload={years?.flatMap(year => ([
              { value: `Total ${year}`, type: 'circle', id: `total_neto_${year}`, color: hide.includes(`total_neto_${year}`) ? 'grey' : colors[year] },
              { value: `Devolución ${year}`, type: 'line', id: `total_devoluciones_${year}`, color: hide.includes(`total_devoluciones_${year}`) ? 'grey' : colors[year] }
            ]))}
          />
          {salesAverage !== null && (
            <ReferenceLine y={salesAverage} stroke='#cccccc' strokeDasharray='3 3'>
              <Label value={`Avg: ${formatNumber(salesAverage)}`} position='insideLeft' />
            </ReferenceLine>
          )}
          {years && years.map(year => (
            <React.Fragment key={year}>
              <Bar dataKey={`total_ventas_${year}`} name={`Ventas ${year}`} fill={colors[year]} barSize={-4} legendType='none' display='none' hide={hide.includes(`total_neto_${year}`)} />
              <Line type='monotone' dataKey={`total_devoluciones_${year}`} name={`Devolución ${year}`} stroke={colors[year]} hide={hide.includes(`total_devoluciones_${year}`)} />
              <Bar dataKey={`total_neto_${year}`} name={`Total ${year}`} fill={colors[year]} barSize={30} legendType='circle' hide={hide.includes(`total_neto_${year}`)}>
                <LabelList dataKey={`total_neto_${year}`} position='top' formatter={(value: any) => formatNumber(value)} fontSize={12} />
              </Bar>
            </React.Fragment>
          ))}
        </ComposedChart>
      </ResponsiveContainer>
    </Card>
  )
}

export default TotalSale